import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StepTileProgressStatus } from "types";
import { getAnnotationStatus } from "redux/CreateDataset/selectors";

export const useIndexTypeStatus = () => {
  const [indexTypeStatus, setIndexTypeStatus] =
    useState<StepTileProgressStatus>(StepTileProgressStatus.DISABLED);

  const annotationStatus = useSelector(getAnnotationStatus);

  // Monitor annotationStatus and update indexTypeStatus accordingly
  useEffect(() => {
    if (annotationStatus === StepTileProgressStatus.COMPLETE) {
      setIndexTypeStatus(StepTileProgressStatus.ACTIVE);
    } else {
      setIndexTypeStatus(StepTileProgressStatus.DISABLED);
    }
  }, [annotationStatus]);

  const markIndexTypeComplete = () => {
    setIndexTypeStatus(StepTileProgressStatus.COMPLETE);
  };

  return {
    indexTypeStatus,
    markIndexTypeComplete,
  };
};
